import { render } from "./leads-edit-requests.vue?vue&type=template&id=b1886268"
import script from "./leads-edit-requests.vue?vue&type=script&lang=js"
export * from "./leads-edit-requests.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__